import { Component, OnInit } from '@angular/core';
import { UnsubscribeProposal, mdlUnsubscribeReq } from '../../Models/UnsubscribeProposal';
import { mdlUnsubscribeReasonsRes } from '../../Models/UnsubscribeMdl';
import { APIService } from '../..//Services/api.service';
import Swal from 'sweetalert2';
import { HttpClient } from '@angular/common/http';
import { EncryptionService } from '../..//Services/EncryptionService';
import { mdlPayloadRequest } from '../..//Models/mdlPayloadRequest';
import { mdlPayloadResponse } from '../..//Models/mdlPayloadResponse';
import { restURL } from '../../Models/restURL';
import { userService } from '../..//Services/userService';
import { TranslateService } from '@ngx-translate/core';
import { MotorStatusMdl } from '../..//Models/MotorStatusMdl';
import { LanguageService } from '../..//Services/languageService';
import { OtpVerifyReq } from '../..//Models/OtpVerifyReq';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
@Component({
  selector: 'app-Unsubscribe',
  templateUrl: './Unsubscribe.html',
  styleUrls: ['./Unsubscribe.css']
})
export class Unsubscribe {
  public bindObj = new mdlUnsubscribeReasonsRes();
  public prObj = new UnsubscribeProposal();
  public isShowLoading = false;
  public emailEntered = false;
  public emailChecked = false;
  public emailExists = false;
  public disableReasonDropdown = false;
  public showResendBtn: boolean = false;
  public timeLeft: number = 180;
  public counter: number = 0;
  public RegNo: number = 0;
  public LngSubscription: Subscription;
  public otpReq: OtpVerifyReq = new OtpVerifyReq();
  public objPayloadRequest: mdlPayloadRequest = new mdlPayloadRequest();
  public objPayloadResponse: mdlPayloadResponse = new mdlPayloadResponse();
  public OTPst: MotorStatusMdl = new MotorStatusMdl();
  public showOTPDialog: boolean = false;
  public showPrintsDialog: boolean = false;
  public interval: any;
  public Lang: any;
  public Lng: string;
  public isEnglish = true;
  public Language: string = 'en';
  isUnsubmitting: boolean = false;
  public isResendShow: boolean = false;
  isUnsubscribeEnabled: boolean = false; // <-- this will enable the Unsubscribe button
  showOtpSection = false;
  otpVerified = false;
  enteredOtp: string = '';
  isOtpVerified: boolean = false; // Track OTP verification
  constructor(public router: Router, private lngService: LanguageService, private apiService: APIService,
  private translate: TranslateService, private http: HttpClient, private Encriptsrvc: EncryptionService,
  public url: restURL, private userInfo: userService) { }

  ngOnInit(): void {
    const lang = sessionStorage.getItem('Language');
    this.isEnglish = lang === 'en';
    this.translate.use(lang);
    document.body.classList.remove("Arabic", "English");
    document.body.classList.add(lang === "ar" ? "Arabic" : "English");
    this.Lng = sessionStorage.getItem('Language') || 'en';
    this.getUnsubscribeReasons();
  }
  async checkEmailExists() {
    const email = this.prObj.UnsubscribeReq.Email.trim() || '';
    this.emailChecked = false;
    this.emailExists = false;
    this.emailEntered = false;

    if (!email) return;

    this.emailEntered = true;

    try {
      const [apiRes, data] = await this.apiService.ConnectAPI(
        'UnsubScribe/GetUnsubscribeDetails',
        { Email: email }
      );

      const statusCode = data.StatusCode;
      this.emailChecked = true;

      if (statusCode === 'S') {
        // Email exists and is not unsubscribed
        this.emailExists = true;
        this.prObj.UnsubscribeReq.InsuredName = data.InsuredName;
        this.prObj.UnsubscribeReq.InsuredIdNo = data.InsuredIdNo;
        this.prObj.UnsubscribeReq.MobileNo = data.MobileNo;
        this.RegNo = data.RegNo;
      } else if (data.StatusDesc === 'You have already unsubscribed.') {
        // Already unsubscribed
        Swal('You have already unsubscribed.',
          'لقد تم إلغاء اشتراكك بالفعل.',
          'warning'
        );
        // ✅ Redirect to BeforeLogin
        this.router.navigate(['BeforeLogin/NewReg']);
      } else {
        // Email does not exist
        Swal(data.StatusDesc,
          data.StatusDescAr || 'Email not found.',
          'warning'
        );
      }
    } catch (err) {
      Swal('Error checking email.', '', 'error');
    }
  }
  allowOnlyNumbers(event: KeyboardEvent) {
  const charCode = event.which ? event.which : event.keyCode;
  if (charCode < 48 || charCode > 57) {
    event.preventDefault();
  }
}

  // When unsubscribe button is clicked
  onUnsubscribeClicked() {

    if (this.otpVerified === true) {
      this.isUnsubmitting = true; // Disable inputs
      this.unsubscribe(); // Already verified, proceed to unsubscribe
      return;
    }

    if (!this.emailExists) {
      Swal(this.translate.instant('Please enter and check a valid email first.'), '', 'warning');
      return;
    }

    const reasonCode = this.prObj.UnsubscribeReq.UnsubscribeReasonCode;
    const otherReason = this.prObj.UnsubscribeReq.OtherReason;

    // 🚫 No reason selected
    if (!reasonCode) {
     Swal(this.translate.instant('Please select a reason.'), '', 'warning');
      return;
    }

    // 🚫 Code is 6 (Other), but no reason entered
    if (reasonCode == 6 && (!otherReason || otherReason.trim() === '')) {
       Swal(this.translate.instant('Please enter your reason.'), '', 'warning');
      return;
    }

    // ✅ Passed all checks — Send OTP
    this.OtpSend();
    this.showOtpSection = true;
    this.otpVerified = false;
    this.isUnsubmitting = true;
  }
  OtpSend() {
    this.isShowLoading = true
    const result = this.http.get('https://api.ipify.org/?format=json').toPromise();
    const IpAddress = JSON.parse(JSON.stringify(result)).ip;
    let Req = {
      RegNo: this.RegNo,
      Lng: this.Language,
      InsuredIdNo: this.prObj.UnsubscribeReq.InsuredIdNo,
      MobileNo: this.prObj.UnsubscribeReq.MobileNo,
      EmailId: this.prObj.UnsubscribeReq.Email,
    };
    this.isShowLoading = true;
    this.objPayloadRequest.Payload = this.Encriptsrvc.EncriptPayload(JSON.stringify(Req));
    this.http.post<mdlPayloadResponse>(this.url.baseURL + "MotorOnline/UnsubscribeOTP", this.objPayloadRequest, this.userInfo.getHttpOptions()).toPromise().then(result => {

      this.objPayloadResponse = result;
      this.OTPst = JSON.parse(JSON.stringify(this.Encriptsrvc.DecriptPayload(this.objPayloadResponse.PayloadResponse)));
      this.isShowLoading = false;
      if (this.OTPst.StatusCode == "S") {
        Swal(this.translate.instant("OTP Send Successfully", "success"))
        this.showOTPDialog = true;
        this.showOTPTimer();
      }
      else if (this.OTPst.StatusCode == "F") {
        Swal(this.translate.instant("OTP Send Successfully"))
      }

    }, (error) => {
      this.isShowLoading = false;
      Swal("Please Try agian later.");
    });
  }
  ResendOTP() {
    this.counter += 1;
    if (this.counter > 5) {
      Swal(this.translate.instant("Maximum resend attempts reached. Please try again later"));
      return;
    }
    let Req = {
      EmailId: this.prObj.UnsubscribeReq.Email,  // <-- Email only  
      RegNo: this.RegNo,
    };

    this.objPayloadRequest.Payload = this.Encriptsrvc.EncriptPayload(JSON.stringify(Req));
    this.isShowLoading = true;
    //this.http.post<MotorStatusMdl>(this.url.baseURL + "Registration/ResendOTP", this.resendObj, this.userInfo.getHttpOptions()).toPromise().then((res) => {
    this.http.post<mdlPayloadResponse>(this.url.baseURL + "MotorOnline/UnsubscribeResendOTP", this.objPayloadRequest, this.userInfo.getHttpOptions()).toPromise().then((res) => {
      //this.st = res;

      //New Line Start
      this.objPayloadResponse = res;
      this.OTPst = JSON.parse(JSON.stringify(this.Encriptsrvc.DecriptPayload(this.objPayloadResponse.PayloadResponse)));
      //NewLine End
      this.isShowLoading = false;

      //this.Lng == "ar" ? Swal.fire(this.st.StatusDescAr) : Swal.fire(this.st.StatusDesc);
      if (this.OTPst.StatusCode == "S") {
        Swal(this.translate.instant("OTP Send Successfully", "success"))
        clearInterval(this.interval);
        this.timeLeft = 180;
        this.showOTPTimer();
        this.isResendShow = false;

      }
    }, (res) => {
      Swal("Try agian");
      this.isShowLoading = false;

    });
  }
  async VerifyOTP() {
    if (!this.enteredOtp) {
      Swal("Please enter OTP", '', 'info');
      return;
    }

    const Req = {
      OTP: this.enteredOtp,  // Use local variable
      RegNo: this.RegNo
    };
    this.isShowLoading = true;
    this.objPayloadRequest.Payload = this.Encriptsrvc.EncriptPayload(JSON.stringify(Req));

    try {
      const result = await this.http.post<mdlPayloadResponse>(
        this.url.baseURL + "MotorOnline/UnsubscribeVerifyOTP", this.objPayloadRequest,
        this.userInfo.getHttpOptions()).toPromise();

      this.objPayloadResponse = result;
      this.OTPst = JSON.parse(JSON.stringify(this.Encriptsrvc.DecriptPayload(this.objPayloadResponse.PayloadResponse)));
      this.isShowLoading = false;

      if (this.OTPst.StatusCode === "F") {
        Swal(this.translate.instant(this.OTPst.StatusDesc), '', 'error');
        return;
      }

      if (this.OTPst.StatusCode === "S") {
        this.otpVerified = true;
        this.showOtpSection = false;

        // ✅ Directly call unsubscribe
        await this.unsubscribe();
      }
    } catch (error) {
      this.isShowLoading = false;
      Swal(this.translate.instant("Please Try again later."), '', 'error');
    }
  }
  showOTPTimer() {
    clearInterval(this.interval);
    this.showResendBtn = false;
    this.timeLeft = 120;
    this.interval = setInterval(() => {
      if (this.timeLeft > 0) {
        this.timeLeft--;
      } else if (this.timeLeft == 0) {
        this.timeLeft = 0;
        this.showResendBtn = true;
      } else {
        this.timeLeft = 180;
      }
    }, 1000)
  }
  async getUnsubscribeReasons() {
    this.Language=this.lngService.lng;
    this.Language=sessionStorage.getItem("Language");
    this.isShowLoading = true;
    try {
      const [apiRes, data] = await this.apiService.ConnectAPI('UnsubScribe/GetUnsubscribeReasons',{});
      this.isShowLoading = false;
      if (apiRes.StatusCode === 'F' || data.StatusCode === 'F') {
        this.disableReasonDropdown = true;
        this.prObj.UnsubscribeReq.UnsubscribeReasonCode = 0;
        Swal(
          this.Language === 'en' ? data.StatusDescAr : data.StatusDesc 
          || 'Failed to load reasons.','','error');
        return;
      }

      this.disableReasonDropdown = false;
      this.bindObj.UnsubscribeList = data.UnsubscribeList;
    } catch (err) {
      this.isShowLoading = false;
      this.disableReasonDropdown = true;
      
    }
  } 
  async unsubscribe() {
    if (!this.emailExists) return;

    try {
      this.prObj.UnsubscribeReq.RegNo = this.RegNo, 0; // Use 0 if null
      this.prObj.UnsubscribeReq.Channel = "B2C_OLD_PORTAL"; // Use 0 if null
      const [apiRes] = await this.apiService.ConnectAPI('UnsubScribe/UnsubscribeSave', this.prObj.UnsubscribeReq);

      if (apiRes.StatusCode === 'S') {
        await Swal(
          'You have unsubscribed successfully!', // Always in English
          'تم إلغاء الاشتراك بنجاح',
          'success'
        );
        this.router.navigate(['BeforeLogin/NewReg']);
        return;
      }

      if (apiRes.StatusCode === 'F') {
        await Swal('You are already unsubscribed',
          'لقد تم إلغاء اشتراكك بالفعل.',
          'error'
        );
        this.router.navigate(['BeforeLogin/NewReg']);
        return;
      }

      // Show other failure reasons
      await Swal(
        this.Language === 'en'
          ? 'Unsubscribe failed: ' + apiRes.StatusDesc
          : apiRes.StatusDescAr,
        '',
        'error'
      );

    } catch (err) {
      Swal('Unsubscribe failed.', '', 'error');
    }

    // Reset only if unsubscribe didn't redirect
    this.prObj.UnsubscribeReq = new mdlUnsubscribeReq();
    this.emailChecked = false;
    this.emailExists = false;
    this.showOTPDialog = false;
    this.otpVerified = true;
    this.showPrintsDialog = true;

    this.isShowLoading = true;
  }
  validateOTPRegex() {
    var re = new RegExp("^[0-9]{4}$");
    if (!re.test(this.otpReq.OTP)) return 'regex'
    return '';
  }
  submitUnsubscribe() {
    if (this.prObj.UnsubscribeReq.UnsubscribeReasonCode === 6 &&
      (!this.prObj.UnsubscribeReq.OtherReason || this.prObj.UnsubscribeReq.OtherReason.trim() === '')) { 
      Swal(this.translate.instant('Please enter a reason for Other', "warning"))
      return;
    }

    // Proceed with unsubscribe logic
  }
}


 



// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Pages/Unsubscribe/Unsubscribe.ts